import React from 'react'
import { observable, action, toJS, computed, makeObservable, runInAction } from 'mobx'
import api from '../service/api'
import AuthStore from './auth.store'

class UserStore {

    user // Logged In Json Info
    userAccounts
    userDebug

    constructor () {
        this.user = { "user_name": "", "user_id": "", "user_email": "", "user_org_code": "", "user_dept_code": "", "user_role": "", "user_auditor": false }
        this.api = api
        this.userAccounts = []
        this.userDebug = {}
        this.userSubjects = []
        this.errorsStatuses = {
            subjects: true,
            academicYears: true,
            academicYearsAndBatches: true
        }
        this.userAcademicYears = []
        this.userBatchesAndSection = { batches: [], sections: [] }
        this.usersAllCurrentBatchesAndSectionList = []
        this.usersLegacyAndCurrentBatchesAndSectionList = []
        this.userCurrentSubjects = []

        //this.fetchUser();
        makeObservable( this, {
            user: observable,
            userDebug: observable,
            userSubjects: observable,
            userAccounts: observable,
            errorsStatuses: observable,
            userAcademicYears: observable,
            userCurrentSubjects: observable,
            userBatchesAndSection: observable,
            usersAllCurrentBatchesAndSectionList: observable,
            usersLegacyAndCurrentBatchesAndSectionList: observable,

            fetchUsersAllBatchesAndSectionList: action,
            fetchUserBatchesAndSection: action,
            fetchUserAcademicYears: action,
            setERPSessionState: action,
            fetchUserSubjects: action,
            setUserAccounts: action,
            capitalizeWords: action,
            setUserDebug: action,
            fetchUsers: action,
            fetchUser: action,
            setUser: action,

            getUsersAllBatchesAndSectionList: computed,
            getUserSubjectsDetails: computed,
            getUserAcademicYears: computed,
            getErrorsStatuses: computed,
            getUserAccounts: computed,
            getUserSubjects: computed,
            getUserDebug: computed,
            getUser: computed,
        } )
    }
    capitalizeWords = ( str ) => {
        return str.replace( /\w\S*/g, function ( txt ) { return txt.charAt( 0 ).toUpperCase() + txt.substr( 1 ).toLowerCase() } )
    }


    fetchUser = async ( options = {} ) => {
        const { userType, skipToast = false } = options

        if ( AuthStore.getToken === null || AuthStore.isTokenExpired() ) {
            console.log( "Session Do not exist!" )
            return { unauth: true, message: "Session does not exists!" }
        } else {
            try {
                let res
                if ( userType === 'candidate' ) {
                    res = await this.api.admissionExams.getUser( { skipToast } )
                } else {
                    res = await this.api.getUser()
                }

                const userData = res?.data?.data
                const sessionData = userData?.session_data

                if ( res?.data?.status && userData ) {

                    // 1. FACULTY / HOD / PRINCIPAL ERP Role
                    if ( userData.user_source === "erp" && sessionData &&
                        ( sessionData.lms_role === "FACULTY" ||
                            sessionData.lms_role === "HOD" ||
                            sessionData.lms_role === "PRINCIPAL" )
                    ) {
                        let erp_data = {
                            "user_name": this.capitalizeWords( sessionData.employee_name ),
                            "user_id": sessionData.user_id,
                            "user_email": "",
                            "user_org_code": sessionData.institute_name_short,
                            "user_dept_code": sessionData.branch_name,
                            "user_role": userData.user_role,
                            "user_status": "active",
                            "user_auditor": sessionData.is_auditor,
                            "image_path": sessionData.image_path
                        }
                        this.setUser( erp_data )

                        // 2. STUDENT ERP Role
                    } else if ( userData.user_source === "erp" && sessionData && sessionData.lms_role === "STUDENT" ) {
                        let erp_data = {
                            "user_name": this.capitalizeWords( sessionData.student_name ),
                            "user_id": sessionData.auid,
                            "user_email": "",
                            "user_auid": sessionData.auid || '',
                            "user_org_code": sessionData.institute_name_short,
                            "user_dept_code": sessionData.branch_name,
                            "user_role": userData.user_role,
                            "user_eligible_status": sessionData.eligible_status,
                            "user_due_status": sessionData.due_status,
                            "image_path": sessionData.image_path,
                            "user_status": "active"
                        }
                        this.setUser( erp_data )

                        // 3. CANDIDATE ERP Role
                    } else if ( sessionData && sessionData.user_source === "erp" && sessionData.user_role === "CANDIDATE" ) {
                        console.log( sessionData )

                        let erp_data = {
                            user_name: this.capitalizeWords( sessionData.candidate_name ),
                            user_role: "CANDIDATE",
                            user_id: sessionData.user_id || sessionData.phone_number || sessionData.pinfl,
                            application_number: sessionData.application_number,
                            program_id: sessionData.program_id,

                        }
                        this.setUser( erp_data )

                        // 4. Standalone Users
                    } else if ( userData.user_source === "standalone" ) {
                        this.setUser( userData )
                    }
                } else {
                    // Fallback if res.data.status or userData doesn't exist
                    this.setUser( { "user_name": "", "user_email": "", "user_org_code": "", "user_dept_code": "" } )
                }

                return { success: true, message: "User fetched successfully!" }
            } catch ( err ) {
                console.log( err )
                if ( err.response ) {
                    return { netError: false, success: false, message: err?.message }
                }
                return { netError: true, success: false, message: "User fetched successfully!" }
            }
        }
    }

    fetchUserSubjects = async ( refresh = false ) => {
        try {
            const res = await this.api.getAllSubjects( { refresh } )
            console.log( res )

            if ( res.data.success ) {
                const subjectsDetails = {
                    years: new Set(),
                    semesters: new Set(),
                    academicYears: new Set(),
                    allSubjects: [],
                    currentSubjects: [],
                    yearWise: false,
                    cached: !refresh
                }

                const currentSubjects = structuredClone( res.data.data || {} )
                // if ( res.data.userRole === "STUDENT" ) {
                //     const currentYears = Object.keys( currentSubjects )
                //     for ( const year of  currentYears  ) {
                //         subjectsDetails.years.add( year )
                //     }

                //     if ( currentYears.length > 0 && Array.isArray( currentSubjects[currentYears[0]] ) )
                //         subjectsDetails.yearWise = true

                //     if ( subjectsDetails.yearWise ) {
                //         for ( const year of currentYears ) {
                //             currentSubjects[year].forEach( sub => sub.legacy_subject = false )
                //             subjectsDetails.allSubjects.push( ...currentSubjects[year] )
                //             subjectsDetails.currentSubjects.push( ...currentSubjects[year] )
                //         }
                //     } else {
                //         for ( const year of currentYears ) {
                //             const sems = Object.keys( currentSubjects[year] || {} )
                //             for ( const sem of sems ) {
                //                 subjectsDetails.semesters.add( sem )
                //                 const subjects = currentSubjects[year][sem]
                //                 subjects.forEach( sub => sub.legacy_subject = false )
                //                 subjectsDetails.allSubjects.push( ...subjects )
                //                 subjectsDetails.currentSubjects.push( ...subjects )
                //             }
                //         }
                //     }

                //     subjectsDetails.years = Array.from( subjectsDetails.years )
                //     subjectsDetails.semesters = Array.from( subjectsDetails.semesters )
                //     console.log( subjectsDetails )
                //     runInAction( () => {
                //         this.userSubjects = subjectsDetails
                //         this.errorsStatuses.subjects = false
                //     } )
                // } else {
                let uniqueIds = {}
                for ( let i = currentSubjects.length - 1; i >= 0; i-- ) {
                    const sub = currentSubjects[i]
                    if ( !uniqueIds[sub.subject_code] ) {
                        uniqueIds[sub.subject_code] = true
                        subjectsDetails.allSubjects.push( sub )
                        subjectsDetails.currentSubjects.push( sub )
                        subjectsDetails.academicYears.add( sub.ac_year )
                    }
                }
                console.log( subjectsDetails )

                subjectsDetails.academicYears = Array.from( subjectsDetails.academicYears )
                runInAction( () => {
                    this.userSubjects = subjectsDetails
                    this.errorsStatuses.subjects = false
                } )
                // }
                return true
            } else {
                runInAction( () => {
                    this.userSubjects = []
                    this.errorsStatuses.subjects = true
                } )
                return false
            }
        }
        catch ( err ) {
            runInAction( () => {
                this.userSubjects = []
                this.errorsStatuses.subjects = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
            // return false
        }
    }


    fetchUserAcademicYears = async ( refresh = false ) => {
        try {
            const { data } = await this.api.getAllBatchAcademicYear( { refresh } )
            if ( data.success ) {
                runInAction( () => {
                    this.userAcademicYears = data.data
                    this.errorsStatuses.academicYears = false
                } )
                return true
            } else {
                runInAction( () => {
                    this.userAcademicYears = []
                    this.errorsStatuses.academicYears = true
                } )
                return false
            }
        } catch ( err ) {
            runInAction( () => {
                this.errorsStatuses.academicYears = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
        }
    }

    fetchUserBatchesAndSection = async ( id, refresh = false ) => {
        try {
            const { data } = await this.api.getAllBatch( { ac_year_id: id, refresh } )
            if ( data.success ) {
                let allBatchesAndSectionsCopy = [...this.usersAllCurrentBatchesAndSectionList]
                const currentBatchesData = data?.data?.batches || []
                currentBatchesData.forEach( batch => {
                    if ( !batch.course_name_short )
                        batch.course_name_short = batch.course_short_name
                } )
                allBatchesAndSectionsCopy = allBatchesAndSectionsCopy.filter( item => +item.ac_year_id !== +id )
                allBatchesAndSectionsCopy.push( ...currentBatchesData || [], ...data?.data?.sections || [] )

                runInAction( () => {
                    this.usersAllCurrentBatchesAndSectionList = allBatchesAndSectionsCopy
                    this.userBatchesAndSection = data.data
                    this.errorsStatuses.academicYearBatch = false
                } )
                return true
            } else {
                runInAction( () => {
                    this.userBatchesAndSection = { batches: [], sections: [] }
                    this.errorsStatuses.academicYearBatch = true
                } )
                return false
            }
        } catch ( err ) {
            runInAction( () => {
                this.errorsStatuses.academicYearBatch = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
        }
    }

    fetchUsersAllBatchesAndSectionList = async ( refresh = false ) => {
        try {
            const { data } = await this.api.getUserAllBatchesAndSections()
            const allBatchesAndSectionslist = []
            const currentBatchesAndSectionslist = []
            const currentBatchesData = data?.data?.batches || []
            currentBatchesData.forEach( batch => {
                if ( !batch.course_name_short )
                    batch.course_name_short = batch.course_short_name
            } )
            allBatchesAndSectionslist.push( ...data?.legacy_data?.batches || [], ...data?.legacy_data?.sections || [] )
            allBatchesAndSectionslist.push( ...currentBatchesData || [], ...data?.data?.sections || [] )
            currentBatchesAndSectionslist.push( ...currentBatchesData || [], ...data?.data?.sections || [] )

            runInAction( () => {
                this.usersAllCurrentBatchesAndSectionList = currentBatchesAndSectionslist
                this.usersLegacyAndCurrentBatchesAndSectionList = allBatchesAndSectionslist
                this.userAcademicYears = data.data.academic_years || []
                this.errorsStatuses.academicYearsAndBatches = false
                this.errorsStatuses.academicYears = false
            } )
        } catch ( err ) {
            runInAction( () => {
                this.errorsStatuses.academicYearsAndBatches = true
                this.errorsStatuses.academicYears = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
        }
    }


    setERPSessionState = ( state ) => {
        AuthStore.setERPSessionState( state )
    }

    // fetchUserSubjects = async () => {
    //     try {
    //         const subjects = await this.api.getAllSubjects()
    //         if ( subjects.data.success ) {
    //             this.userSubjects = subjects.data.data
    //             return true
    //         } else {
    //             this.userSubjects = []
    //             return false
    //         }
    //     } catch ( err ) {
    //         console.log( err )
    //     }
    // }

    fetchUsers = async () => {
        ///console.log(AuthStore.isTokenExpired())
        if ( AuthStore.getToken === null || AuthStore.isTokenExpired() ) {
            console.log( "Session Do not exist!" )
        } else {
            try {
                const res = await this.api.getUsers()
                //console.log(res)
                this.setUserAccounts( res["data"]["data"] )
            } catch ( err ) {
                console.log( err )
            }
        }

    }

    setUserAccounts ( userAccounts ) {
        this.userAccounts = userAccounts
    }

    createUserAccount = async ( payload ) => {
        try {
            const res = await this.api.createUser( payload )
            console.log( res )
        } catch ( error ) {

        }
    }

    updateUserStatus = async ( payload ) => {

        await this.api.updateUserStatus( payload )
        this.fetchUsers()

    }

    updatePassword = async ( payload ) => {
        try {
            const res = await this.api.updatePassword( payload )
            console.log( res["data"]["message"] )
        } catch ( err ) {

        }
    }

    setUser ( user ) {
        this.user = user
    }
    setUserDebug = ( data ) => {
        this.userDebug = data
    }

    get getUserDebug () {
        return toJS( this.userDebug )
    }

    userDebugTimetable = async ( payload ) => {
        return await this.api.findUserDebugTimetable( payload )
        // .then((res)=>{
        //     console.log(`User Debug : `, res["data"])
        // }).catch((err)=>{

        // })
    }

    // get compute_func()
    get getUser () {
        return toJS( this.user )
    }

    get getUserAcademicYears () {
        return toJS( this.userAcademicYears )
    }

    get getUsersAllBatchesAndSectionList () {
        return toJS( this.usersAllCurrentBatchesAndSectionList )
    }

    get getUserAccounts () {
        return toJS( this.userAccounts )
    }

    get getUserSubjects () {
        return toJS( this.userSubjects )
    }

    get getUserSubjectsDetails () {
        const subjects = toJS( this.userSubjects )
        return subjects
    }

    get getErrorsStatuses () {
        return toJS( this.errorsStatuses )
    }

}

// decorate(UserStore, {
//     user:observable,
//     userAccounts:observable,
//     userDebug:observable,
//     getUser:computed,
//     getUserDebug:computed,
//     setUser:action,
//     setUserDebug:action,
//     getUserAccounts:computed,
//     setUserAccounts:action,
//     fetchUser:action,
//     fetchUsers:action,
//     capitalizeWords:action
// })


const UserStoreInstance = new UserStore()

export default UserStoreInstance

const UserStoreContext = React.createContext()

export const UserStoreProvider = ( { children, store } ) => {
    return (
        <UserStoreContext.Provider value={store}>{children}</UserStoreContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useUserStore = () => React.useContext( UserStoreContext )